const milestones = [
  { year: '2018', title: '品牌創立', desc: '在台中西區一間小小的選品工作室起步，以正品 Outlet 為核心理念，服務第一批忠實顧客。' },
  { year: '2020', title: '旗艦門市開幕', desc: '台中旗艦店正式開幕，引入專業造型顧問服務，讓每位來訪的女性都能獲得個人化搭配建議。' },
  { year: '2022', title: '品牌合作擴展', desc: '與超過 30 個國際知名女裝品牌建立直接合作關係，確保貨源透明、100% 正品無虞。' },
  { year: '2024', title: '線上商城上線', desc: '正式推出線上購物平台，讓台灣各地的女性都能輕鬆入手品牌 Outlet 精選單品。' },
];

const values = [
  { icon: 'ri-shield-check-line', title: '100% 正品保障', desc: '所有商品皆來自品牌直接授權管道，附原廠標籤與保證書，讓妳安心購買。' },
  { icon: 'ri-eye-line', title: '透明貨源', desc: '清楚標示每件商品的品牌、季節與入庫原因，讓妳了解每一分錢花在哪裡。' },
  { icon: 'ri-map-pin-2-line', title: '台中門市試穿', desc: '歡迎親臨台中旗艦門市，實際試穿每件商品，造型師在旁提供專業搭配建議。' },
  { icon: 'ri-recycle-line', title: '永續時尚理念', desc: '透過讓優質服飾延續生命週期，減少時尚浪費，為地球與妳的衣櫥同時做出正確選擇。' },
  { icon: 'ri-heart-line', title: '女性優先思維', desc: '所有選品、定價、服務設計，都以「對女性真正有益」為最高準則。' },
  { icon: 'ri-customer-service-2-line', title: '溫暖售後服務', desc: '完善的退換貨政策、LINE 即時客服，購物後的每一步我們都陪妳走。' },
];

export default function BrandStory() {
  return (
    <section className="bg-[#FDFAF5] py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">

        {/* Brand Story */}
        <div className="flex flex-col lg:flex-row gap-14 items-center mb-24">
          <div className="flex-1 max-w-xl">
            <p className="font-sans text-[1rem] text-[#C49A3E] tracking-widest mb-4 font-medium">OUR STORY</p>
            <h2 className="font-serif text-[1.5rem] md:text-[2.125rem] text-[#2C2118] font-semibold leading-[1.4] mb-6">
              時尚不應是奢侈，<br />而是每位女性日常的選擇權
            </h2>
            <p className="font-sans text-[1.1875rem] text-[#2C2118]/65 leading-[1.75] mb-5">
              我們深信，每一位女性都值得擁有高品質的服飾，卻不必為此傾盡所有。
              透過直接與品牌合作、精選換季庫存與下架精品，讓妳以驚喜的 Outlet 價格，穿出自信與品味。
            </p>
            <p className="font-sans text-[1.1875rem] text-[#2C2118]/65 leading-[1.75]">
              台中旗艦門市提供專業搭配諮詢，所有商品 100% 正品保證，讓購物成為一種享受，而非負擔。
              從第一件選品到現在，我們始終只做一件事：讓台灣女性用對的價格，穿出屬於自己的故事。
            </p>
          </div>
          <div className="flex-1 w-full max-w-lg">
            <div className="w-full h-[360px] md:h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=two%20stylish%20women%20shopping%20in%20a%20warm%20minimalist%20fashion%20boutique%20interior%20cream%20tones%20elegant%20clothing%20racks%20soft%20lighting%20friendly%20atmosphere%20Taichung%20boutique%20store%20candid%20editorial%20photography&width=600&height=420&seq=brand-story-img&orientation=landscape"
                alt="品牌故事"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Milestones */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <p className="font-sans text-[1rem] text-[#C49A3E] tracking-widest mb-3 font-medium">MILESTONES</p>
            <h2 className="font-serif text-[1.5rem] md:text-[2.125rem] text-[#2C2118] font-semibold leading-[1.4]">
              我們走過的足跡
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {milestones.map((m) => (
              <div key={m.year} className="bg-white border border-[#F5EDD8] rounded-2xl p-6 hover:border-[#E8D09A] transition-all duration-300">
                <span className="inline-block font-serif text-[2rem] text-[#C49A3E] font-semibold mb-3">{m.year}</span>
                <h3 className="font-serif text-[1.1875rem] text-[#2C2118] font-semibold mb-2 leading-[1.5]">{m.title}</h3>
                <p className="font-sans text-[1rem] text-[#2C2118]/60 leading-[1.75]">{m.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Values */}
        <div>
          <div className="text-center mb-12">
            <p className="font-sans text-[1rem] text-[#C49A3E] tracking-widest mb-3 font-medium">OUR VALUES</p>
            <h2 className="font-serif text-[1.5rem] md:text-[2.125rem] text-[#2C2118] font-semibold leading-[1.4]">
              我們的核心承諾
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((v) => (
              <div key={v.title} className="bg-white border border-[#F5EDD8] rounded-2xl p-7 hover:border-[#E8D09A] transition-all duration-300 group">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FAF5EB] rounded-xl mb-5 group-hover:bg-[#F5EDD8] transition-colors duration-300">
                  <i className={`${v.icon} text-[#C49A3E] text-2xl`}></i>
                </div>
                <h3 className="font-serif text-[1.1875rem] text-[#2C2118] font-semibold mb-2 leading-[1.5]">{v.title}</h3>
                <p className="font-sans text-[1rem] text-[#2C2118]/60 leading-[1.75]">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
